import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";

interface Props {
  isOpen: boolean;
}

const ModalAlreadyResponse = ({ isOpen }: Props) => {
  const onConfirm = () => {
    window.location.reload();
  };
  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            Ya respondiste esta pregunta en otro navegador
          </h2>
          <p className="text-center text-color-02">
            Actualiza esta página para seguir tu examen aquí, o <br />
            continúa en el otro navegador.
          </p>
        </div>
        <div className="flex justify-center gap-lg">
          <Button
            color="primary"
            onClick={onConfirm}
            text="Actualizar página"
            data-testid="btn-reload"
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalAlreadyResponse;
